import React, {memo} from 'react';
import {UiCenter, UiSpinner} from '.';

interface Props {
  text?: string;
  style?: React.CSSProperties;
}

export const UiPageLoading = memo(function UiPageLoading({text = 'Loading', style}: Props) {
  return (
    <UiCenter className="height-100-vh" style={style}>
      <UiSpinner size="xl" label={text} />
    </UiCenter>
  );
});
